export const GET_CASES = "GET_CASES";
export const SAVE_CARE_MANAGER = "SAVE_CARE_MANAGER";
export const SAVE_CASES = "SAVE_CASES";
export const SAVE_CONTACTS = "SAVE_CONTACTS";
export const SET_LOADING_CASES = "SET_LOADING_CASES";
export const SAVE_ALL_DOCUMENTS = "SAVE_ALL_DOCUMENTS";
export const SAVE_ALL_MESSAGES = "SAVE_ALL_MESSAGES";
export const MERGE_MANAGER_CONTACT = "MERGE_MANAGER_CONTACT";
export const CHANGE_STATUS = "CHANGE_STATUS";

export const getCases = () => ({
	type: GET_CASES
});

export const saveCases = (listCases) => ({
	type: SAVE_CASES,
	listCases
});

export const saveCareManager = (careManager) => ({
	type: SAVE_CARE_MANAGER,
	careManager
});

export const saveContacts = (listContacts) => ({
	type: SAVE_CONTACTS,
	listContacts
});

export const setLoadingCases = (bool) => ({
	type: SET_LOADING_CASES,
	bool
});

export const saveAllDocuments = (allDocuments) => ({
	type: SAVE_ALL_DOCUMENTS,
	allDocuments
});

export const saveAllMessages = (allMessages) => ({
	type: SAVE_ALL_MESSAGES,
	allMessages
});

export const mergeManagerContact = () => ({
	type: MERGE_MANAGER_CONTACT
});

export const changeStatus = (status, idCase) => ({
	type: CHANGE_STATUS,
	status,
	idCase,
});